import { Message } from 'components/message'
import { CepService } from './cep.service'
import { of } from 'rxjs/observable/of';

export class CepNavigationObserver {

  constructor(cep) {
    this.cep = cep;
    this.service = new CepService();
  }

  next(res) {
    if(res.data) {
        of(this.service.setValueCokieByName("LojaVirtualPanvelCepNavegacao", res.data))
        .subscribe(r => window.location.reload());
    }
  }

  error(error) {
    const msg = (error.status && error.status == 404) ?  "Não foi possível alterar seu cep" : error.data.mensagem
    new Message(msg)
  }

  complete() {}

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/cep-navigation/cep-navigation.observer.js